<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="control mt1">
        <div class="columns">
          <div class="column">
            <div id="card-number-element"></div>
          </div>
          <div class="column">
            <div id="card-cvc-element"></div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div id="card-expiry-element"></div>
          </div>
          <div class="column">
            <input
              type="tel"
              name="postal_code"
              v-model="postalCode"
              placeholder="Zip Code"
              class="stripe-input"
            />
          </div>
        </div>

        <div v-if="showNext">
          Your payment has been received. Please click next...
        </div>
        <div id="card-errors" role="alert" class="mb4"></div>

        <button
          v-if="!showNext"
          :class="[
            'button is-primary is-fullwidth next-button',
            { 'is-loading': stripeWorking }
          ]"
          @click="submitPayment"
        >
          Submit Payment
        </button>

        <next-button
          v-if="showNext"
          :id="question.id"
          :choice="choice"
        ></next-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import maskedInput from "vue-text-mask";
import baseQuestion from "./baseQuestion";

const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
const elements = stripe.elements();

const style = {
  base: {
    fontFamily: "'Avenir', 'Helvetica', Arial, sans-serif",
    color: "#000",
    fontSize: "17px",
    "::placeholder": {
      color: "#CFD7E0"
    }
  }
};

// Create an instance of the card Element.
const cardNumberElement = elements.create("cardNumber", { style });
const cardExpiryElement = elements.create("cardExpiry", { style });
const cardCvcElement = elements.create("cardCvc", { style });

export default {
  name: "stripe",

  mixins: [baseQuestion],

  data() {
    return {
      showNext: false,
      postalCode: null,
      stripeWorking: false
    };
  },

  components: {
    maskedInput
  },

  methods: {
    submitPayment() {
      const options = {
        address_zip: this.postalCode
      };

      this.stripeWorking = true;
      stripe
        .createToken(cardNumberElement, options)
        .then(({ token, error }) => {
          if (error) {
            this.showErrors(error);
          } else {
            this.choice = token;
            this.showNext = true;
            this.$store.dispatch("interview/setNext", true);
          }
        })
        .catch(({ error }) => {
          let message = _.has(error, "message") ? error.message : error;
          if (!message) {
            message =
              "There was an error with our card. Please check all fields.";
          }
          this.showErrors({ message });
        })
        .finally(() => {
          this.stripeWorking = false;
        });
    },
    showErrors(error) {
      const displayError = document.getElementById("card-errors");
      if (error) {
        displayError.textContent = error.message;
      } else {
        displayError.textContent = "";
      }
    }
  },
  mounted() {
    // Add an instance of the card Element into the `card-element` <div>.
    cardNumberElement.mount("#card-number-element");
    cardExpiryElement.mount("#card-expiry-element");
    cardCvcElement.mount("#card-cvc-element");

    cardNumberElement.addEventListener("change", ({ error }) => {
      this.showErrors(error);
    });
    cardExpiryElement.addEventListener("change", ({ error }) => {
      this.showErrors(error);
    });
    cardCvcElement.addEventListener("change", ({ error }) => {
      this.showErrors(error);
    });
  }
};
</script>

<style lang="scss" scoped>
.stripe-input {
  font-family: "Avenir", "Helvetica", Arial, sans-serif;
  color: #000;
  font-size: 17px;
  background-color: transparent;
  border: none;
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
  line-height: 1.2em;
  height: 1.2em;
  font-weight: 400;
  text-transform: uppercase;

  &:focus {
    outline: none;
  }
}
</style>
